var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import axios from "axios";
import * as Sentry from "@sentry/browser";
import errorStrings from "./strings";
import * as codes from "./codes";
import { setData, getItem } from "./storage";

var getTimezone = function getTimezone() {
  return /\((.*)\)/.exec(new Date().toString())[1];
};

var getBranchLink = function getBranchLink() {
  return (getItem("branchLink") || {}).value;
};

var setProfile = function setProfile(setAccessToken, setUser, access_token, config) {
  return __awaiter(void 0, void 0, void 0, function* () {
    var strings = getStrings(config);

    try {
      var userRes = yield axios({
        method: "get",
        url: "".concat(getUrls(config).getUserProfile),
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer ".concat(access_token)
        }
      });

      if (userRes.data && userRes.data.result && userRes.data.result.username) {
        var user = userRes.data.result;
        setAccessToken(access_token);
        setUser(user);
        setData({
          user: user,
          access_token: access_token
        });
        return user;
      }
    } catch (error) {
      Sentry.captureException(error);
    }

    return {
      error_code: codes.unknown,
      message: strings.unknown_server_error
    };
  });
};

export var googleLogin = function googleLogin(setAccessToken, setUser, config) {
  return function (token) {
    return __awaiter(void 0, void 0, void 0, function* () {
      var strings = getStrings(config);

      try {
        var result = yield axios({
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          },
          url: "".concat(getUrls(config).googleLogin),
          data: {
            idToken: token,
            language: config.locale,
            branchLink: getBranchLink(),
            timezone: getTimezone(),
            clientId: config.fitplanApiLoginClientId
          }
        });

        if (result.data && result.data.result && result.data.result.access_token) {
          return yield setProfile(setAccessToken, setUser, result.data.result.access_token, config);
        }

        return {
          error_code: codes.google_unknown,
          message: strings.google_unknown_error
        };
      } catch (error) {
        Sentry.captureException(error);
        return {
          error_code: codes.google_unknown,
          message: strings.google_unknown_error
        };
      }
    });
  };
};
export var facebookLogin = function facebookLogin(setAccessToken, setUser, config) {
  return function (token) {
    return __awaiter(void 0, void 0, void 0, function* () {
      var strings = getStrings(config);

      try {
        var result = yield axios({
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          },
          url: "".concat(getUrls(config).facebookLogin),
          data: {
            language: config.locale,
            accessToken: token,
            timezone: getTimezone(),
            clientId: config.fitplanApiLoginClientId,
            branchLink: getBranchLink()
          }
        });

        if (result.data && result.data.result && result.data.result.access_token) {
          return yield setProfile(setAccessToken, setUser, result.data.result.access_token, config);
        }

        return {
          error_code: codes.facebook_unknown,
          message: strings.facebook_unknown_error
        };
      } catch (error) {
        Sentry.captureException(error);
        return {
          error_code: codes.facebook_unknown,
          message: strings.facebook_unknown_error
        };
      }
    });
  };
};
export var emailLogin = function emailLogin(setAccessToken, setUser, config) {
  return function (username, password) {
    return __awaiter(void 0, void 0, void 0, function* () {
      var strings = getStrings(config);

      try {
        /***
         * mobile follows jwt login process which is based off of oauth2 login
         * below are the rfc on how login is done
         * https://tools.ietf.org/html/rfc6749
         * https://tools.ietf.org/html/rfc7519
         * https://tools.ietf.org/html/rfc7523
         * https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS
         */
        var loginData = new FormData();
        var authorizationHeader = btoa("".concat(config.fitplanApiLoginClientId, ":").concat(config.fitplanApiLoginClientSecret));
        loginData.set("username", username);
        loginData.set("password", password);
        loginData.set("grant_type", "password");
        loginData.set("client_id", config.fitplanApiLoginClientId);
        loginData.set("client_secret", config.fitplanApiLoginClientSecret);
        var result = yield axios({
          method: "post",
          headers: {
            Accept: "*",
            "Content-Type": "multipart/form-data",
            Authorization: "Basic ".concat(authorizationHeader)
          },
          url: "".concat(getUrls(config).token),
          data: loginData
        });

        if (result.data && result.data.access_token) {
          var profile = yield setProfile(setAccessToken, setUser, result.data.access_token, config);
          return profile;
        } else if (result.data && result.data.error) {
          return {
            error_code: codes.login,
            message: strings.login_error
          };
        }

        return {
          error_code: codes.unknown,
          message: strings.unknown_server_error
        };
      } catch (error) {
        if (error.response && error.response.data && error.response.data.error) {
          return {
            error_code: codes.login,
            message: strings.login_error
          };
        }

        Sentry.captureException(error);
        return {
          error_code: codes.unknown,
          message: strings.unknown_server_error
        };
      }
    });
  };
};
export var emailSignup = function emailSignup(setAccessToken, setUser, config) {
  return function (user) {
    return __awaiter(void 0, void 0, void 0, function* () {
      var strings = getStrings(config);

      try {
        var result = yield axios({
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          },
          url: "".concat(getUrls(config).userSignup),
          data: Object.assign({
            branchLink: getBranchLink(),
            subscriptionEmails: false,
            language: config.locale,
            timezone: getTimezone(),
            clientId: config.fitplanApiLoginClientId
          }, user)
        });

        if (result.data && result.data.result && result.data.result.access_token) {
          var profile = yield setProfile(setAccessToken, setUser, result.data.result.access_token, config);
          return profile;
        } else if (result.data && result.data.error) {
          return {
            error_code: codes.login,
            message: strings.login_error
          };
        }

        return {
          error_code: codes.unknown,
          message: strings.unknown_server_error
        };
      } catch (error) {
        if (error.response && error.response.data && error.response.data.error) {
          var err = error.response.data.error;

          if (err === "User already exists") {
            return {
              error_code: codes.user_exists,
              message: strings.user_already_exists
            };
          } else if (typeof err === "string") {
            return {
              error_code: codes.unknown,
              message: err
            };
          }
        }

        Sentry.captureException(error);
        return {
          error_code: codes.unknown,
          message: strings.unknown_server_error
        };
      }
    });
  };
};

var getUrls = function getUrls(config) {
  return {
    root: "".concat(config.apiBaseUrl, "/"),
    base: "".concat(config.apiBaseUrl, "/web/"),
    token: "".concat(config.apiBaseUrl, "/oauth/token"),
    userLogin: "".concat(config.apiBaseUrl, "/website/user/login"),
    userSignup: "".concat(config.apiBaseUrl, "/website/user/signup"),
    getStripePlans: "".concat(config.apiBaseUrl, "/web/stripe/payment/plans"),
    submitPayment: "".concat(config.apiBaseUrl, "/web/stripe/submit/payment"),
    submitOneTimePayment: "".concat(config.apiBaseUrl, "/web/stripe/submit/onetime/payment"),
    getUserProfile: "".concat(config.apiBaseUrl, "/v2/user/profile?includeOneTimeProducts=true"),
    googleLogin: "".concat(config.apiBaseUrl, "/v2/user/signup/google"),
    facebookLogin: "".concat(config.apiBaseUrl, "/v2/user/signup/facebook/2"),
    forgotPassword: "".concat(config.apiBaseUrl, "/v2/user/password/forgot")
  };
};

var getStrings = function getStrings(config) {
  return config.locale === 'es' ? errorStrings.es : errorStrings.en;
};